import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Stack,
  Divider,
  Link as MuiLink,
} from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { useNavigate } from "react-router-dom";

// =========================================================
// CONTACT SECTION DATA
// =========================================================

const LABEL_COLOR = "#ffffff";
const HOVER_COLOR = "#4dabf7";

const phones = [
  "+91-9626856685",
  "+91-9840369993",
  "+65-86121295",
];

const emails = [
  "enquiry@lidertechnology.com",
  "impulzlms@gmail.com",
  "lidertechnologysolutions@gmail.com",
];

const website = "www.lidertechnology.com";

const locations = [
  {
    title: "CHENNAI · HEAD OFFICE",
    lines: [
      "No 381, T.H Road",
      "Thiruvottiyur, Chennai 600019",
      "Tamilnadu, India",
    ],
  },
  {
    title: "KUMBAKONAM",
    lines: [
      "No 59, 3rd Floor Kamaraj Road",
      "John Selvaraj Nagar, Kumbakonam 612001",
      "Tamilnadu, India",
    ],
  },
  {
    title: "SINGAPORE",
    lines: [
      "No 207, #10-186",
      "Serangoon Central, Singapore 550207",
    ],
  },
];

// =========================================================
// SMALL LABEL (PHONE / EMAIL / WEBSITE / LOCATION TITLE)
// =========================================================

const SmallLabel = ({ children }) => (
  <Typography
    sx={{
      fontSize: "0.75rem",
      fontWeight: 700,
      color: LABEL_COLOR,
      textTransform: "uppercase",
      mb: 1,
    }}
  >
    {children}
  </Typography>
);

const Footer = () => {
  const navigate = useNavigate();

  // =========================================================
  // IMPULZ HOVER STATE
  // =========================================================

  const [impulzOpen, setImpulzOpen] = useState(false);

  // =========================================================
  // IMPULZ PRODUCTS
  // =========================================================

  const impulzItems = [
    {
      label: "ImpulZ School LMS",
      url: "https://9ggv8r3x-3000.inc1.devtunnels.ms/product/school-lms",
      icon: <SchoolIcon />,
    },
    {
      label: "ImpulZ College LMS",
      url: "https://9ggv8r3x-3000.inc1.devtunnels.ms/product/college-lms",
      icon: <AccountBalanceIcon />,
    },
    {
      label: "ImpulZ TNPSC",
      url: "https://9ggv8r3x-3000.inc1.devtunnels.ms/product/tnpsc",
      icon: <AssignmentIcon />,
    },
    {
      label: "ImpulZ JEE / NEET",
      url: "https://9ggv8r3x-3000.inc1.devtunnels.ms/product/jee-neet",
      icon: <PsychologyIcon />,
    },
    {
      label: "ImpulZ Kids",
      url: "https://9ggv8r3x-3000.inc1.devtunnels.ms/product/kids",
      icon: <ChildCareIcon />,
    },
  ];

  // =========================================================
  // PRODUCTS
  // =========================================================

  const products = [
    {
      label: "ImpulZ",
      hasSubMenu: true,
    },
    {
      label: "Lider Connect",
      path: "/products/lider-connect",
    },
    {
      label: "Lider ERP",
      path: "/products/lider-erp",
    },
    {
      label: "Koottu",
      path: "/products/bower-cred",
      icon: <AccountBalanceWalletIcon />,
    },
    {
      label: "Circuit",
      path: "/products/circuit",
    },
    {
      label: "Lider SecureGate",
      path: "/Products/iclever-gate",
    },
    {
      label: "iPathway",
      path: "/products/pathway",
    },
    {
      label: "Missed Call Alert",
      path: "/products/missed-call-alert",
    },
    {
      label: "Thedal Directory",
      path: "/products/thedal-dictionary",
    },
    {
      label: "Kiosk",
      path: "/Products/kiosk",
    },
  ];

  // =========================================================
  // SERVICES
  // =========================================================

  const services = [
    {
      label: "Website Development",
      path: "/services/website-development",
    },
    {
      label: "App Development",
      path: "/services/app-development",
    },
    {
      label: "Software Testing",
      path: "/services/software-testing",
    },
    {
      label: "Manual Testing",
      path: "/services/manual-testing",
    },
    {
      label: "Automation Testing",
      path: "/services/software-automation-testing",
    },
    {
      label: "Cloud & Data Analytics",
      path: "/services/cloud-data-analytics",
    },
    {
      label: "R & D Lab",
      path: "/services/research-and-development",
    },
  ];

  // =========================================================
  // SOCIAL ICONS
  // =========================================================

  const icons = [
    {
      icon: <InstagramIcon />,
      label: "Instagram",
      link:
        "https://www.instagram.com/lider_technolgy_solutions?igsh=MW9hMW1nenBqOHYyMA==F",
      color:
        "linear-gradient(45deg, #833AB4, #C13584, #E1306C, #FD1D1D, #F56040, #FCAF45)",
    },
    {
      icon: <YouTubeIcon />,
      label: "YouTube",
      link: "https://youtube.com/@lidertechnology?si=enP6uF3mW9e64A1j",
      color: "#FF0000",
    },
    {
      icon: <FacebookIcon />,
      label: "Facebook",
      link: "https://facebook.com",
      color: "#1877F2",
    },
  ];

  // =========================================================
  // EMAIL STYLE
  // =========================================================

  const emailTextStyle = {
    color: "#cccccc",
    textDecoration: "none",
    minWidth: 0,
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    lineHeight: 1.5,

    "&:hover": {
      color: "#00e676",
      textDecoration: "underline",
    },
  };

  // =========================================================
  // EMAIL ROW
  // =========================================================

  const EmailRow = ({ email }) => (
    <Stack
      direction="row"
      spacing={1}
      alignItems="flex-start"
      sx={{
        width: "100%",
        minWidth: 0,
      }}
    >
      <EmailIcon
        sx={{
          fontSize: 18,
          color: "#00e676",
          flexShrink: 0,
          mt: "2px",
        }}
      />

      <Typography
        component="a"
        href={`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        sx={emailTextStyle}
      >
        {email}
      </Typography>
    </Stack>
  );

  // =========================================================
  // LINK STYLE
  // =========================================================

  const linkSx = {
    mb: 1.1,
    color: "#b0b0b0",
    cursor: "pointer",
    fontSize: "0.9rem",
    transition: "all 0.2s ease",

    "&:hover": {
      color: "#4dabf7",
      transform: "translateX(4px)",
    },
  };

  // =========================================================
  // HEADING STYLE (same as PRODUCTS / SERVICES)
  // =========================================================

  const headingSx = {
    fontWeight: 700,
    mb: 2,
    color: "#ffffff",
    fontSize: "1.1rem",
    textDecoration: "underline",
    textUnderlineOffset: "6px",
  };

  // =========================================================
  // OPEN NORMAL ITEM
  // =========================================================

  const openItem = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  // =========================================================
  // OPEN IMPULZ ITEM
  // =========================================================

  const openImpulzItem = (url) => {
    // External / another website
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        bgcolor: "#0a0a0a",
        color: "#ffffff",
        pt: 8,
        borderTop: "1px solid #333",
        overflow: "visible",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          px: {
            xs: 3,
            sm: 4,
            md: 6,
            lg: 8,
          },
        }}
      >
        <Grid container spacing={{ xs: 5, md: 4 }}>
          {/* =====================================================
              ABOUT
          ===================================================== */}

          <Grid item xs={12} md={3}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: "#ffffff",
                fontSize: {
                  xs: "1.5rem",
                  md: "1.7rem",
                },
              }}
            >
              Lider Technology Solutions Pvt. Ltd.
            </Typography>

            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.8,
                color: "#b0b0b0",
                maxWidth: 380,
                fontSize: "0.95rem",
              }}
            >
              We provide reliable technology solutions with a commitment to
              innovation, quality and client success. Empowering businesses
              through software and engineering excellence.
            </Typography>
          </Grid>

          {/* =====================================================
              PRODUCTS
          ===================================================== */}

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={headingSx}>
              PRODUCTS
            </Typography>

            {products.map((item, index) => {
              const isImpulz = item.label === "ImpulZ";

              // =================================================
              // IMPULZ WITH HOVER SUBMENU
              // =================================================

              if (isImpulz) {
                return (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      width: "fit-content",
                    }}
                    onMouseEnter={() => setImpulzOpen(true)}
                    onMouseLeave={() => setImpulzOpen(false)}
                  >
                    {/* IMPULZ MAIN ITEM */}

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        mb: 1.1,
                        minHeight: 28,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          ...linkSx,
                          mb: 0,
                        }}
                      >
                        ImpulZ
                      </Typography>

                      <ArrowForwardIosIcon
                        sx={{
                          fontSize: 12,
                          ml: 1,
                          color: "#777",
                          transition: "transform 0.2s ease",
                          transform: impulzOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    </Box>

                    {/* =================================================
                        IMPULZ SUBMENU
                    ================================================= */}

                    <Box
                      sx={{
                        position: "absolute",

                        // IMPORTANT:
                        // No gap between parent and submenu
                        left: "100%",
                        bottom: "-5px",

                        width: 285,

                        background: "#ffffff",

                        borderRadius: "10px",

                        boxShadow: "0 10px 35px rgba(0,0,0,0.30)",

                        border: "1px solid rgba(0,0,0,0.08)",

                        p: 1,

                        zIndex: 9999,

                        display: impulzOpen ? "block" : "none",
                      }}
                      // Keep submenu open while mouse is inside
                      onMouseEnter={() => setImpulzOpen(true)}
                      onMouseLeave={() => setImpulzOpen(false)}
                    >
                      {impulzItems.map((child) => (
                        <Box
                          key={child.label}
                          onClick={() => openImpulzItem(child.url)}
                          sx={{
                            display: "flex",
                            alignItems: "center",

                            px: 1.5,
                            py: 1.4,

                            borderRadius: "8px",

                            cursor: "pointer",

                            transition: "all 0.2s ease",

                            "&:hover": {
                              backgroundColor: "rgba(37, 99, 235, 0.08)",
                            },
                          }}
                        >
                          {/* ICON */}

                          <Box
                            sx={{
                              width: 38,
                              height: 38,

                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",

                              color: "#2563eb",

                              flexShrink: 0,

                              mr: 1.5,
                            }}
                          >
                            {child.icon}
                          </Box>

                          {/* TEXT */}

                          <Typography
                            sx={{
                              color: "#374151",
                              fontSize: "14px",
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {child.label}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                );
              }

              // =================================================
              // NORMAL PRODUCT
              // =================================================

              return (
                <Typography
                  key={index}
                  variant="body2"
                  onClick={() => openItem(item)}
                  sx={linkSx}
                >
                  {item.label}
                </Typography>
              );
            })}
          </Grid>

          {/* =====================================================
              SERVICES
          ===================================================== */}

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={headingSx}>
              SERVICES
            </Typography>

            {services.map((item, index) => (
              <Typography
                key={index}
                variant="body2"
                onClick={() => navigate(item.path)}
                sx={linkSx}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>

          {/* =====================================================
              CONTACT DETAILS + OUR LOCATIONS
          ===================================================== */}

          <Grid item xs={12} md={5}>
            <Grid container spacing={{ xs: 5, sm: 4, md: 4 }}>
              {/* ---------- CONTACT DETAILS ---------- */}

              <Grid item xs={12} sm={6}>
                <Typography variant="h6" sx={headingSx}>
                  CONTACT DETAILS
                </Typography>

                <Box sx={{ mt: 3 }}>
                  {/* PHONE */}

                  <SmallLabel>Phone</SmallLabel>

                  <Stack spacing={0.8}>
                    {phones.map((phone, idx) => (
                      <MuiLink
                        key={phone}
                        href={`tel:${phone.replace(/[^+\d]/g, "")}`}
                        underline="none"
                        sx={{
                          color: idx === 0 ? "#cccccc" : "#cccccc",
                          fontSize: "0.95rem",
                          fontWeight: idx === 0 ? 400 : 400,
                          width: "fit-content",
                          "&:hover": { color: HOVER_COLOR },
                        }}
                      >
                        {phone}
                      </MuiLink>
                    ))}
                  </Stack>

                  <Divider sx={{ bgcolor: "#333", my: 2 }} />

                  {/* EMAIL */}

                  <SmallLabel>Email</SmallLabel>

                  <Stack spacing={1}>
                    {emails.map((email) => (
                      <EmailRow key={email} email={email} />
                    ))}
                  </Stack>

                  <Divider sx={{ bgcolor: "#333", my: 2 }} />

                  {/* WEBSITE */}
{/* 
                  <SmallLabel>Website</SmallLabel>

                  <MuiLink
                    href={`https://${website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    sx={{
                      color: "#ffffff",
                      fontSize: "0.95rem",
                      fontWeight: 700,
                      "&:hover": { color: HOVER_COLOR },
                    }}
                  >
                    {website}
                  </MuiLink> */}
                </Box>
              </Grid>

              {/* ---------- OUR LOCATIONS ---------- */}

              <Grid item xs={12} sm={6}>
                <Typography variant="h6" sx={headingSx}>
                  OUR LOCATIONS
                </Typography>

                <Stack spacing={3} sx={{ mt: 3 }}>
                  {locations.map((item) => (
                    <Box key={item.title}>
                      <SmallLabel>{item.title}</SmallLabel>

                      {item.lines.map((line) => (
                        <Typography
                          key={line}
                          variant="body2"
                          sx={{
                            color: "#cccccc",
                            lineHeight: 1.6,
                          }}
                        >
                          {line}
                        </Typography>
                      ))}
                    </Box>
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* =====================================================
            DIVIDER
        ===================================================== */}

        <Divider
          sx={{
            my: 5,
            bgcolor: "#333",
            height: "1px",
          }}
        />

        {/* =====================================================
            BOTTOM BAR
        ===================================================== */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            flexDirection: {
              xs: "column",
              sm: "row",
            },

            gap: 3,
            pb: 4,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#b0b0b0",
              fontSize: "0.85rem",
              textAlign: {
                xs: "center",
                sm: "left",
              },
            }}
          >
            © {new Date().getFullYear()} Lider Technology Solutions Pvt.
            Ltd. All rights reserved.
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 3,
              justifyContent: "center",
            }}
          >
            {icons.map((item, index) => (
              <Box
                key={index}
                textAlign="center"
              >
                <IconButton
                  component="a"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    border: "2px solid #555",
                    color: "#fff",
                    position: "relative",
                    transition: "all 0.4s ease",

                    "&:hover": {
                      background: item.color,
                      borderColor: "transparent",
                      transform: "scale(1.1)",
                      boxShadow:
                        "0 0 15px rgba(255,255,255,0.3)",
                    },
                  }}
                >
                  {item.icon}
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
